// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__3-UI8","main":"App_main__1z4M1","sidemenu":"App_sidemenu__ZW2Ir"};